import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import VerContainer from '../../components/@ver/ver-container';
import GenericContainer from '../../components/@container/generic-container';

const VehicleEmergencyResponse: NextPage = () => (
  <Layout title="Vehicle Emergency Response Guides">
    <GenericContainer
      title="Vehicle Emergency Response Guides"
      breadcrumb={{ url: '/', text: 'Back to Home' }}
      fullWidth={true}
    >
      <VerContainer />
    </GenericContainer>
  </Layout>
);

export default VehicleEmergencyResponse;
